import React, { Component } from 'react'
import { connect } from 'react-redux'
import './styles.css'

import PageWrapper from '../../components/PageWrapper'
import WhiteBox from '../../components/WhiteBox'
import ReactTooltip from 'react-tooltip'
import Sidebar from 'react-sidebar'
import DocDrawer from './drawer'
import {countries} from '../../lib/countries'

class Documentation extends Component {
    state = {
        phase: 0,
        userAttributes: null,
        errorMessage: null,
        username: null,
        cognitoUser: null,
        disabled: true,
        changePasswordDisabled: true,
        adFormCountries: []
    }

    componentDidMount(){
        this.setState({adFormCountries: countries})
    }

    render() {
        const sidebar = <DocDrawer />

        const sidebarProps = {
            sidebar: sidebar,
            docked: true,
            open: true,
            onSetOpen: null
        }

        let marginTopParagraph = '40px'

        return (
            <Sidebar {...sidebarProps}>
                <div className="">
                    <div className="doc-page" style={{ 'margin-bottom': '100px', 'text-align': 'left', padding: '20px', background: '#f1f2f7' }}>
                        <WhiteBox>
                            <div className="row" id="doc_integrations">
                                <div className="col">
                                    <h2 style={{ 'border-bottom': '1px solid lightgray', 'margin-bottom': '20px' }} className="">
                                        License an Audience
                                    </h2>
                                    <p>
                                        License your Audiences and make them available to be used in your Campaign targeting. It's possible to set the cookie
                                        duration (default 30 days), the minimun CPM and the validity of the license.
                                        <br />
                                        <h3 style={{ marginTop: marginTopParagraph }} className="">
                                            Dashboard: License creation
                                        </h3>
                                        <p>
                                            Licensing procedure follows those steps:
                                            <ol>
                                                <li>
                                                    Clicking the <u>"New License"</u> button you can select an audience to license.
                                                </li>
                                                <li>After the selection of the audience it's required to select the dmp and the destination product.</li>
                                                <li>
                                                    Clicking <u>"Save"</u> button will create the license.
                                                </li>
                                            </ol>
                                        </p>
                                        <h3 style={{ marginTop: marginTopParagraph }} className="">
                                            Type of Products Licensed
                                        </h3>
                                        <p>
                                            <ul>
                                                <li>
                                                    <b>Adform Marketplace</b>: you can license on the adform marketplace in all countries supported by adform.
                                                </li>
                                                <li>
                                                    <b>Audiencerate Reseller</b>: is a special license where you can publish your audiences on Audiencerate
                                                    marketplace.
                                                </li>
                                                <li>
                                                    <b>Open Marketplace</b>: is a <u>global market</u> where we sell on all Google marketplace buyers.
                                                </li>
                                                <li>
                                                    <b>DoubleClick for Publishers Global</b>
                                                </li>

                                                <li>
                                                    <b>Private Buyer</b>: sell through a Seat ID (identifies the buyer) for exampe an agency.
                                                    <br />
                                                    <i>Products:</i>
                                                    <ul>
                                                        <li>
                                                            <b>DV360 Advertiser</b>
                                                        </li>
                                                        <li>
                                                            <b>DV360 Partner</b>
                                                        </li>
                                                        <li>
                                                            <b>DoubleClick for Publishers</b>
                                                        </li>
                                                    </ul>
                                                </li>
                                            </ul>

                                            <span>
                                                <h3>Using the API you need to choose one of the following product id:</h3>

                                                    For dmp <u>'ddp'</u> the field <u>dmpProductId</u> can have the values:
                                                    
                                                    <ul>
                                                        <li>'INVITE_ADVERTISER' (DV360 Advertiser)</li>
                                                        <li>'INVITE_PARTNER' (DV360 Partner)</li>
                                                        <li>'DFP_BY_GOOGLE' (DoubleClick for Publishers)</li>
                                                        <li>'DFP_BY_GOOGLE_GLOBAL' (DoubleClick for Publishers Global)</li>
                                                        <li>'AR_MARKETPLACE' (Google DV360 Marketplace)</li>
                                                    </ul>
                                                   
                                                   For dmp <u>'adform'</u> you can set:
                                                    <ul>
                                                        <li>'ADFORM_MARKETPLACE'</li>
                                                    </ul>
                                                    
                                                    
                                                   For Audiencerate Marketplace you will need to use <u>'ar'</u> as dmp and:
                                                    <ul>
                                                        <li>'AR_RESELLER' (Audience Marketplace)</li>
                                                    </ul>
                                                    
                                                </span>

                                                
                                        </p>
                                        <h3 style={{ marginTop: marginTopParagraph }} className="">
                                            Technical Details
                                        </h3>
                                        <p>
                                            Licensing procedure follows those steps:
                                            <ol>
                                                <li>
                                                    Call <a href="https://apidocs.audiencerate.com/#/default/post_audiencelink">Audience link API</a> to connect
                                                    the audience to the dmp selected.
                                                </li>
                                                <li>
                                                    Create the new license calling the{' '}
                                                    <a href="https://apidocs.audiencerate.com/#/default/post_license">POST license API</a>{' '}
                                                </li>
                                            </ol>
                                        </p>
                                        <div className="alert alert-warning">
                                            It's mandatory to call <a href="https://apidocs.audiencerate.com/#/default/post_audiencelink">Audience link API</a>{' '}
                                            <b>before</b> creating a new license.
                                        </div>
                                    </p>
                                </div>
                            </div>


                            <div className="row" id="adform">
                                <div className="col">
                                    <br/>
                                    <br/>
                                    <h2 style={{ 'border-bottom': '1px solid lightgray', 'margin-bottom': '20px' }} className="">
                                        Licensing on Adform - Bulk license guide
                                    </h2>
                                    <p>
                                        On Adform, unlike Google, is possibile to license one audience in multiple agencies or in multiple countries in a single step. <br/>
                                        When licensing you set the field <b>'dmpClientId'</b> based on the selection made on the license page.
                                    </p>
                                    <p>
                                        <h3 style={{ marginTop: marginTopParagraph }} className="">
                                            Single agency selection
                                        </h3>

                                        When wanting to select a single agency the 'dmpClientId' field is needed to be set to a specific value corresponding to the proprietary Adform Agency ID.
                                        You can find those on the adform dmp or by calling Audiencerate API to fetch agencies IDs: 
                                        <a href="https://apidocs.audiencerate.com/#/default/get_adform_agencies">API /adform/agencies</a>. 
                                    </p>
                                    
                                    <p>
                                        <h3 style={{ marginTop: marginTopParagraph }} className="">
                                            All countries selection
                                        </h3>
                                        If you need to license all the countries available on adform you need to set 'dmpClientId' to <b>ADF_AC</b> that indicates all countries selected.
                                    </p>
                                    <p>
                                        <h3 style={{ marginTop: marginTopParagraph }} className="">
                                            One country selection
                                        </h3>

                                        When selecting all the agencies of one country the 'dmpClientId' is needed to be set with a placeholder value based on 
                                        the adform country code and iso code. You can find those codes in the table below or on the adform dmp platform or by calling Audiencerate API to fetch countries IDs:
                                        <a href="https://apidocs.audiencerate.com/#/default/get_adform_countries">API /adform/countries</a>. 

                                        <br/>
                                        <br/>
                                        If you need to license all agencies for a single country you need to set 'dmpClientId' as a placeholder following the format: <b>ADF_A_&lt;countryIsoCode&gt;_&lt;adformCountryIDCode&gt;</b>, 
                                        for example ADF_A_IT_11 stands for all agencies in Italy (IT is the country iso code, 11 is the country ID on adform). 

<br/>
<br/>
                                        <u>Here is the list of all Adform countries codes:</u>

                                        <br/>
                                        <br/>

                                        <div class="table-responsive" style={{
                                            'overflow': 'auto',
                                            'maxHeight': '600px'
                                        }}>

                                            <table className="table table-striped">
                                                <thead>
                                                    <tr>
                                                        <th>Country</th>
                                                        <th>ISO Code</th>
                                                        <th>Adform Country ID</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.state.adFormCountries.filter(el => el.iso2Code).map(el => (
                                                        <tr>
                                                            <td>{el.name}</td>
                                                            <td>{el.iso2Code}</td>
                                                            <td>{el.id}</td>
                                                        </tr>
                                                    )
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>

                                    </p>



                                   
                                </div>
                            </div>
                        </WhiteBox>
                    </div>
                </div>
            </Sidebar>
        )
    }
}

export default connect(
    state => ({}),
    {}
)(Documentation)
